import './bootstrap';
import {createRoot} from 'react-dom/client';
import {createInertiaApp} from '@inertiajs/react'
import {GoogleOAuthProvider} from "@react-oauth/google";

const appName = import.meta.env.VITE_APP_NAME || 'Lense';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: name => {
        const pages = import.meta.glob('./Pages/**/*.jsx', {eager: true})
        return pages[`./Pages/${name}.jsx`]
    }, setup({el, App, props}) {
        const root = createRoot(el);


        root.render(
            <GoogleOAuthProvider
                clientId="267128966677-dt6vh7nmfe1lctt758mi6ih41srqa75u.apps.googleusercontent.com">
                <App {...props} />
            </GoogleOAuthProvider>);
    },
    progress: {
        color: '#4B5563',
    },
});
